// Group sets store the legacy spelling of system and asset types. Types without a legacy
// spelling (e.g. Stormwater / swPipe) are stored under their schema id, as getNewAssetIds assumes.
const GROUP_SET_SYSTEM_TYPE: Record<string, string> = {
	SanitarySewer: 'Sanitary Sewer',
	WaterDistribution: 'Water Distribution',
};
const GROUP_SET_ASSET_TYPE: Record<string, string> = {
	wwPipe: 'pipe',
	pipe: 'pipe',
};

export const toGroupSetSystemType = (systemTypeId: string): string =>
	GROUP_SET_SYSTEM_TYPE[systemTypeId] ?? systemTypeId;

export const toGroupSetAssetType = (assetTypeId: string): string => GROUP_SET_ASSET_TYPE[assetTypeId] ?? assetTypeId;
